type Size = 'sm' | 'md' | 'lg' | 'xl'

const SIZE_CONFIG = {
  sm: { fontSize: '1.25rem', svgWidth: 40, svgHeight: 40 },
  md: { fontSize: '1.5rem', svgWidth: 56, svgHeight: 56 },
  lg: { fontSize: '2rem', svgWidth: 72, svgHeight: 72 },
  xl: { fontSize: '2.5rem', svgWidth: 96, svgHeight: 96 },
}

type Props = { size?: Size; className?: string }

export function KemyoonLogo({ size = 'md', className = '' }: Props) {
  const config = SIZE_CONFIG[size]

  return (
    <div
      className={`inline-flex items-center font-bold tracking-tight ${className}`}
      style={{ fontSize: config.fontSize }}
    >
      <span className="text-foreground">kemy</span>
      <svg
        width={config.svgWidth}
        height={config.svgHeight}
        viewBox="0 0 128 128"
        className="inline-block mx-0.5"
        aria-label="oo"
      >
        <circle cx="40" cy="64" r="28" fill="#dc2626" stroke="white" strokeWidth="3" />
        <circle cx="88" cy="64" r="28" fill="#dc2626" stroke="white" strokeWidth="3" />
        <circle cx="40" cy="64" r="9" fill="white" />
        <circle cx="88" cy="64" r="9" fill="white" />
      </svg>
      <span className="text-foreground">n</span>
    </div>
  )
}
